import React from 'react';
import { formatBadgeCount } from '../../../utils/numberUtils';
import './SidebarNav.css';

/**
 * Left rail navigation.
 * @param {Array<{ id: string, label: string, items: Array<{
 *   id: string, label: string, icon: string, active?: boolean,
 *   badge?: number, onSelect: () => void
 * }> }>} groups
 */
export default function SidebarNav({
  groups = [],
  navRef,
  mobileOpen = false,
  onNavigate,
  densityToggle = null,
}) {
  return (
    <nav
      ref={navRef}
      className={`app-sidebar ${mobileOpen ? 'mobile-open' : ''}`}
      aria-label="Primary"
    >
      <div className="app-sidebar-brand">
        {densityToggle}
        <span className="app-sidebar-brand-label">Navigation</span>
      </div>
      {groups.map((group, index) => (
        <React.Fragment key={group.id}>
          {index > 0 && <div className="app-sidebar-divider" aria-hidden="true" />}
          <div className="app-sidebar-group" role="group" aria-label={group.label}>
            <span className="app-sidebar-group-label">{group.label}</span>
            {group.items.map((item) => (
              <button
                key={item.id}
                type="button"
                className={[
                  'app-sidebar-item',
                  item.active ? 'active' : '',
                  item.badge ? 'app-sidebar-item--badge' : '',
                ]
                  .filter(Boolean)
                  .join(' ')}
                title={item.badge ? `${item.label} (${item.badge})` : item.label}
                data-label={item.label}
                onClick={() => {
                  item.onSelect?.();
                  onNavigate?.();
                }}
              >
                <span className="app-sidebar-icon" aria-hidden="true">
                  {item.icon}
                </span>
                <span className="app-sidebar-label">{item.label}</span>
                {item.badge > 0 && (
                  <span className="app-sidebar-badge">{formatBadgeCount(item.badge)}</span>
                )}
              </button>
            ))}
          </div>
        </React.Fragment>
      ))}
    </nav>
  );
}
